import { render, staticRenderFns } from "./ReviewsTab.vue?vue&type=template&id=47b356c4&"
import script from "./ReviewsTab.vue?vue&type=script&lang=js&"
export * from "./ReviewsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports